import React from 'react';
import { Tab, TabItem } from './stripe-form-styles';
import ACHPaymentLimitModal from '../components/tot-pay/ach-payment-limit-modal';
import { ACH_PAYMENT_TAB } from './checkout-constants';


export default function ACHTab({
  isactive,
  achTotal,
  setActiveTab,
  openLimitWarning,
  setOpenLimitWarning
}) {


  return (
    <>
      <ACHPaymentLimitModal open={openLimitWarning} setOpen={setOpenLimitWarning} />
      <Tab
        isactive={isactive}
        onClick={() => {
          if (achTotal > 6000) { // 6k is ach amount limit for stripe right now
            setOpenLimitWarning(true);
          } else {
            setActiveTab(ACH_PAYMENT_TAB);
          }
        }}
      >
        <TabItem>
          <img
            src='../../assets/ach-icon.svg'
            alt=''
            height='14px'
          />
        </TabItem>
        <TabItem>
          <span
            style={{
              width: '100%',
              height: '12px',
              fontSize: '12px',
              lineHeight: '1',
              padding: '5px 0 2px',
            }}
          >
            Bank Account
          </span>
        </TabItem>
      </Tab>
    </>
  );
}
